import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EmployeeAdd, EmployeeData, Review } from '../../models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  constructor(
    private http: HttpClient
  ) { }

  public getAll() {
    return this.http.get<{
      code: string;
      data: Array<EmployeeData>
    }>(`${environment.host}/organization/employee/`);
  }

  public getById(employeeId: number) {
    return this.http.get<{
      code: string;
      data: EmployeeData
    }>(`${environment.host}/organization/employee/${employeeId}/`);
  }

  public add(data: EmployeeAdd) {
    const formData = new FormData();
    formData.append('photo', data.photo);
    formData.append('organization_id', data.organization_id?.toString() || '');
    formData.append('job_title', data.job_title);
    formData.append('work_experience', data.work_experience);
    formData.append('schedule', JSON.stringify(data.schedule));
    formData.append('services', JSON.stringify(data.services));
    formData.append('employee', JSON.stringify(data.employee));

    return this.http.post<{
      code: string;
      data: EmployeeData
    }>(`${environment.host}/organization/employee/`, formData);
  }

  public edit(employeeId: number, data: EmployeeAdd) {
    const formData = new FormData();
    if (data.photo) {
      formData.append('photo', data.photo);
    }
    formData.append('organization_id', data.organization_id?.toString() || '');
    formData.append('job_title', data.job_title);
    formData.append('info', data.info);
    formData.append('schedule', JSON.stringify(data.schedule));
    if (data.services) formData.append('services', JSON.stringify(data.services));
    formData.append('employee', JSON.stringify(data.employee));

    return this.http.put<{
      code: string;
      data: EmployeeData
    }>(`${environment.host}/organization/employee/${employeeId}/`, formData);
  }

  public remove(employeeId: number) {
    return this.http.delete<{
      code: string;
      data: EmployeeData
    }>(`${environment.host}/organization/employee/${employeeId}/`);
  }
}
